export default __webpack_public_path__ + "static/media/systemsStars.d87f7b9d.png";